import { render, staticRenderFns } from "./AppointmentEncounterType.vue?vue&type=template&id=2c1ebbd2&scoped=true"
import script from "./AppointmentEncounterType.vue?vue&type=script&lang=js"
export * from "./AppointmentEncounterType.vue?vue&type=script&lang=js"
import style0 from "./AppointmentEncounterType.vue?vue&type=style&index=0&id=2c1ebbd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ebbd2",
  null
  
)

export default component.exports